import type { SelectProps } from 'antd'

export const getPageSizeChanger = (popupClassName: string): SelectProps => ({
  showSearch: false,
  placement: 'bottomLeft',
  getPopupContainer: () => document.body,
  classNames: { popup: { root: popupClassName } },
})
